import { render, staticRenderFns } from "./HospitalizationMenu.vue?vue&type=template&id=510d4af5"
import script from "./HospitalizationMenu.vue?vue&type=script&lang=js"
export * from "./HospitalizationMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports